import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import className from 'classnames';
import TemplateField from '../../TemplateField';
import styles from './styles.css';

function FieldAccordion({
  fields,
  snapshot,
  draggableProvided,
  fieldName,
  fieldIndex,
}) {
  const usePortal = snapshot.isDragging;

  const field = (
    <div
      ref={draggableProvided.innerRef}
      {...draggableProvided.draggableProps}
      // {...draggableProvided.dragHandleProps}
      className={className(styles.FieldAccordionDraggableWrapper, {
        [`${styles['FieldAccordionDraggableWrapper--dragging']}`]:
          snapshot.isDragging,
      })}
      role="button"
    >
      <TemplateField
        key={`${fieldName}-template-field-${fieldIndex}`}
        fieldName={`${fieldName}`}
        fieldData={fields.value[fieldIndex]}
        index={fieldIndex}
        parentFields={fields}
        onRemove={() => fields.remove(fieldIndex)}
        dragHandleProps={draggableProvided.dragHandleProps}
      />
    </div>
  );

  if (!usePortal) {
    return field;
  }

  const container = document.getElementById('ModuleContainer');
  return ReactDOM.createPortal(field, container);
}

FieldAccordion.propTypes = {
  fields: PropTypes.object,
  fieldName: PropTypes.string,
  fieldIndex: PropTypes.number,
  snapshot: PropTypes.object,
  draggableProvided: PropTypes.object,
};

export default FieldAccordion;
